export enum EApiCallStateNames {
  CALENDAR_EVENTS_LIST = 'CALENDAR_EVENTS_LIST',
  NEWS_LIST = 'NEWS_LIST',
  TAGS_LIST = 'TAGS_LIST',
  DOCUMENT_ARCHIVE_LIST = 'DOCUMENT_ARCHIVE_LIST',
  SURVEY_ARCHIVE_LIST = 'SURVEY_ARCHIVE_LIST',
  DEMO = 'DEMO',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
  PAGINATION = 'PAGINATION',
  SORTING = 'SORTING',
  FILTERS = 'FILTERS',
  SORT_EVENT_LIST_TITLE = 'SORT_EVENT_LIST_TITLE',
  SORT_EVENT_LIST_TYPE = 'SORT_EVENT_LIST_TYPE',
  SORT_EVENT_LIST_START_DATE = 'SORT_EVENT_LIST_START_DATE',
  SORT_EVENT_LIST_END_DATE = 'SORT_EVENT_LIST_END_DATE',
  SORT_EVENT_CREATED_BY = 'SORT_EVENT_CREATED_BY',
  SORT_EVENT_MODIFIED_BY = 'SORT_EVENT_MODIFIED_BY',
  SORT_EVENT_LIST_CREATED = 'SORT_EVENT_LIST_CREATED',
  SORT_EVENT_LIST_MODIFIED = 'SORT_EVENT_LIST_MODIFIED',
  SORT_NEWS_TITLE = 'SORT_NEWS_TITLE',
  SORT_NEWS_PUBLISHED_FROM = 'SORT_NEWS_PUBLISHED_FROM',
  SORT_NEWS_PUBLISHED_TO = 'SORT_NEWS_PUBLISHED_TO',
  SORT_NEWS_CREATED_BY = 'SORT_NEWS_CREATED_BY',
  SORT_NEWS_MODIFIED_BY = 'SORT_NEWS_MODIFIED_BY',
  SORT_NEWS_CREATED = 'SORT_NEWS_CREATED',
  SORT_NEWS_MODIFIED = 'SORT_NEWS_MODIFIED',
  SORT_FS_ITEM_NAME = 'SORT_FS_ITEM_NAME',
  SORT_FS_ITEM_CONTENT_TYPE = 'SORT_FS_ITEM_CONTENT_TYPE',
  SORT_FS_ITEM_CREATED_BY = 'SORT_FS_ITEM_CREATED_BY',
  SORT_FS_ITEM_MODIFIED_BY = 'SORT_FS_ITEM_MODIFIED_BY',
  SORT_FS_ITEM_MODIFIED = 'SORT_FS_ITEM_MODIFIED',
  SORT_FS_ITEM_CREATED = 'SORT_FS_ITEM_CREATED',
  SORT_TAGS_TITLE = 'SORT_TAGS_TITLE',
  SORT_TAGS_DESCRIPTION = 'SORT_TAGS_DESCRIPTION',
  SORT_TAGS_CREATED_BY = 'SORT_TAGS_CREATED_BY',
  SORT_TAGS_MODIFIED_BY = 'SORT_TAGS_MODIFIED_BY',
  SORT_TAGS_MODIFIED = 'SORT_TAGS_MODIFIED',
  SORT_TAGS_CREATED = 'SORT_TAGS_CREATED',
}
